<template>
  <div>
    <div v-if="label">
      <slot name="label">
        <label class="control-label">
          {{ label }}
        </label>
      </slot>
    </div>
    <slot>
      <select v-model="object[field]" style="width: 80%">
        <option v-for="(obj, index) in objects" :value="obj[value]" :key="index">{{ obj.name }}</option>
      </select>
    </slot>
  </div>
</template>

<script>
export default {
  props:{
    object: null,
    field: null,
    objects: {},
    label: null,
    name: null,
    value: null
  }
}
</script>

<style>
</style>
